import { OrderViewType } from "@widgets/ecommerce/types/OrderViewType";
import { AppendIfPrefixExists } from "../../../../../modules/sitePaths";

export function generateOrderDetailHref(
  biOrderId: number | null | undefined,
  salesOrder: string | null | undefined,
  webOrderId: number | null | undefined,
) {
  let orderNumber: string | undefined;

  if (biOrderId != null) {
    orderNumber = `${salesOrder}`;
  } else if (webOrderId != null) {
    orderNumber = `${webOrderId}`;
  }

  // OrderDetailsPage only fetches when the :salesOrder path param is truthy,
  // and web orders are not guaranteed to have a sales order number.
  const detailKey = salesOrder || webOrderId?.toString();

  if (!detailKey) {
    return { href: undefined, orderNumber };
  }

  const params = new URLSearchParams();
  if (biOrderId != null) {
    params.set("biOrderId", `${biOrderId}`);
  }
  if (webOrderId != null) {
    params.set("webOrderId", `${webOrderId}`);
  }
  const query = params.toString();

  const href = AppendIfPrefixExists(
    `/orders/details/${encodeURIComponent(detailKey)}${query ? `?${query}` : ""}`,
  );

  return { href, orderNumber };
}

export const ORDER_VIEW_TABS: OrderViewType[] = [
  OrderViewType.Storefront,
  OrderViewType.My,
  OrderViewType.PendingApprovals,
  OrderViewType.All,
];

export const TAB_LABEL: Record<OrderViewType, string> = {
  [OrderViewType.Storefront]: "STOREFRONT ORDERS",
  [OrderViewType.My]: "MY ORDERS",
  [OrderViewType.PendingApprovals]: "PENDING APPROVALS",
  [OrderViewType.All]: "ALL ORDERS",
};

